import { useTranslation } from "react-i18next";
import { PromoPageHeader } from "../components/PromoPageHeader";
import { ConnectionHealth } from "../components/ConnectionHealth";

export default function ConnectionHealthPage() {
  const { t } = useTranslation();
  return (
    <div className="space-y-10" data-testid="connection-health-page">
      <PromoPageHeader
        overline={t("promo.nav.connections")}
        title={t("promo.conn.pageTitle")}
        description={t("promo.conn.pageSubtitle")}
      />
      <ConnectionHealth title={t("promo.conn.status")} />
    </div>
  );
}
